import { Box } from '@mui/material';

// ----------------------------------------------------------------------

// Indicatore ambiente: cornice arancio attorno alla viewport + linguetta
// "AMBIENTE DI TEST" appesa in alto al centro. Serve a non scambiare mai una
// tab di sandbox/staging/localhost per quella di produzione.
//
// Solo il valore esatto 'production' lo sopprime: se VITE_ENV manca o contiene
// un valore imprevisto la cornice compare comunque (fail-safe — meglio un
// avviso di troppo che una modifica fatta sull'ambiente sbagliato).
//
// È un overlay puro (position fixed + pointerEvents none): non sposta il
// layout e non intercetta i click, quindi header, sidebar e contenuto non
// vanno ricalibrati.

const COLOR = '#e65100';

// su iOS standalone / WebView il contenuto va sotto la status bar
// (viewport-fit=cover); su desktop questi valgono 0
const INSET_TOP = 'env(safe-area-inset-top, 0px)';
const INSET = `${INSET_TOP} env(safe-area-inset-right, 0px) env(safe-area-inset-bottom, 0px) env(safe-area-inset-left, 0px)`;

// sopra modal (1300), snackbar (1400) e tooltip (1500): resta visibile anche
// con un dialog aperto
const Z_INDEX = 2000;

export default function EnvBanner() {
  if (import.meta.env.VITE_ENV === 'production') {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          inset: INSET,
          border: `3px solid ${COLOR}`,
          pointerEvents: 'none',
          zIndex: Z_INDEX,
          '@media print': { display: 'none' },
        }}
      />

      <Box
        sx={{
          position: 'fixed',
          top: INSET_TOP,
          left: '50%',
          transform: 'translateX(-50%)',
          height: 18,
          lineHeight: '18px',
          px: 1.25,
          bgcolor: COLOR,
          color: '#fff',
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: 0.8,
          whiteSpace: 'nowrap',
          borderRadius: '0 0 4px 4px',
          pointerEvents: 'none',
          zIndex: Z_INDEX,
          '@media print': { display: 'none' },
        }}
      >
        AMBIENTE DI TEST
      </Box>
    </>
  );
}
